<script lang="ts">
    import {onMount} from "svelte";
    import SpaceListView from "./SpaceListView.svelte";

    export let params;
    const _ = params;

    onMount(() => {
    });


</script>

<div class="home-page standard-page">
    <div class="lead-text-area">
        Ready は開発中やリリース予定のアプリとその周辺情報を効率的に管理するためのサービスです。
    </div>

    <h1 class="space-title">スペースを選択してください</h1>

    <div class="space-list-area">
        <SpaceListView/>

    </div>


</div>
<style lang="scss">
    .home-page {

        .lead-text-area {
            margin-top: 20px;
            text-align: center;
        }

        .space-title {
            text-align: center;
            margin-top: 60px;
        }

        .welcome-message-area {
            max-width: 49%;
            flex-grow: 1;

        }

        .space-list-area {
            flex-grow: 1;

        }
    }
</style>